// Datos ficticios de ejemplo — plantilla "Nova" (15 años, noche glamurosa).

export const datosEjemplo = {
  tipoEvento: "quince",
  plantillaId: "quince-nova",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "La cuenta regresiva", titulo: "Falta poco para brillar", textoFinalizado: "¡Hoy es la noche!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "Dónde y cuándo", titulo: "La fiesta" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Reservá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Mis momentos", titulo: "Luces de mis quince" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El programa", titulo: "La noche, paso a paso" },
    { id: "menciones", visible: true, orden: 6, etiqueta: "Mi equipo", titulo: "Los que siempre están" },
    { id: "video", visible: true, orden: 7, etiqueta: "Mi video", titulo: "Así llegué hasta acá" },
    { id: "musica", visible: true, orden: 8, etiqueta: "La playlist", titulo: "Lo que suena esta noche" },
    { id: "regalos", visible: true, orden: 9, etiqueta: "Mesa de regalos", titulo: "Un detalle, si querés" },
    { id: "rsvp", visible: true, orden: 10, etiqueta: "Confirmación", titulo: "¿Te sumás?" },
    { id: "enlaces", visible: true, orden: 11, etiqueta: "Datos útiles", titulo: "Información adicional" },
    { id: "accesos", visible: true, orden: 12, etiqueta: "Participá", titulo: "Sumate a los recuerdos" },
    { id: "cierre", visible: true, orden: 13 },
  ],

  protagonista: {
    nombre: "Antonella",
    insignia: "XV",
    fraseIntroductoria: "Mis XV años",
    mensajePortada:
      "Una noche única merece compañía única. Vení a celebrar conmigo.",
    mensajeCierre:
      "Gracias por ser parte de esta noche que voy a recordar para siempre.",
    textoBotonEntrada: "Entrar a la fiesta",
  },

  evento: {
    fechaISO: "2027-04-17T21:00:00-03:00",
    fechaLegible: "Sábado 17 de abril de 2027",
    fechaCorta: "17 · 04 · 2027",
    ciudad: "Lambaré, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Antonella sonriendo",
      },
      {
        src: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Luces de la pista de baile",
      },
      {
        src: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Brindis con luces de bengala",
      },
      {
        src: "https://images.unsplash.com/photo-1531058020387-3be344556be6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Decoración de la fiesta",
      },
    ],
  },

  eventos: [
    {
      id: "fiesta",
      etiqueta: "Recepción y fiesta",
      lugar: "Salón Jardín Mburucuyá",
      direccion: "Av. Cacique Lambaré esq. Ytororó, Lambaré",
      horario: "21:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Lambar%C3%A9+Paraguay",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "XV años de Antonella",
    descripcion: "Fiesta desde las 21:00 h en Salón Jardín Mburucuyá, Lambaré.",
    texto: "Sábado 17 de abril de 2027 · Lambaré, Paraguay. Agendá la noche.",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2027-04-17T21:00:00-03:00",
    finISO: "2027-04-18T04:00:00-03:00",
    ubicacion: "Salón Jardín Mburucuyá, Lambaré, Paraguay",
  },

  itinerario: [
    { hora: "21:00", titulo: "Recepción", descripcion: "Alfombra roja y bienvenida.", icono: "brillo" },
    { hora: "21:45", titulo: "Ingreso y vals", descripcion: "El gran momento de la noche.", icono: "musica" },
    { hora: "22:30", titulo: "Cena", descripcion: "Menú de estación.", icono: "cena" },
    { hora: "23:30", titulo: "Show en vivo", descripcion: "Sorpresa sobre el escenario.", icono: "fiesta" },
    { hora: "00:30", titulo: "Hora loca", descripcion: "Cotillón luminoso y pista abierta.", icono: "copas" },
    { hora: "03:30", titulo: "Cierre", descripcion: "Último brindis.", icono: "corazon" },
  ],

  menciones: [
    {
      nombre: "Patricia Silva",
      rol: "Mamá",
      foto: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Hugo Silva",
      rol: "Papá",
      foto: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Martina López",
      rol: "Mejor amiga",
      foto: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Diego Silva",
      rol: "Hermano",
      foto: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play cuando quieras. La música nunca arranca sola.",
  },

  regalos: {
    mensaje: "Lo importante es que estés. Si querés sumar un detalle, te dejo mis mesas de regalos.",
    tiendas: [
      {
        nombre: "Studio Regalos",
        url: "https://www.instagram.com",
        nota: "Mesa «XV Antonella»",
      },
    ],
    alternativa: {
      titulo: "Lluvia de sobres",
      texto: "encontrás el buzón en la entrada del salón.",
    },
  },

  rsvp: {
    mensaje:
      "La pista te espera. Confirmame tu asistencia para guardarte tu lugar.",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 17 de marzo de 2027",
  },

  enlaces: [
    { texto: "Dress code: gala", url: "https://www.pinterest.com" },
    { texto: "#LosXVDeAnto", url: "https://www.instagram.com" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejame tu mensaje de esta noche.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Subí tus fotos y videos de la fiesta.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
